module.exports = __webpack_public_path__ + "img/profile-tick.5ffc0b3d.svg";